import { selector } from 'recoil'
import { alphamapClient } from 'src/clients'
import { AMAuthTiles } from 'src/common-services'
import { keyFactory } from 'src/utils/recoil'

const settingKey = keyFactory('tiles')

export const auth = selector<AMAuthTiles>({
  key: settingKey('auth'),
  get: async () => {
    const response = await alphamapClient.tiles.getAuth()
    return response
  },
})
